import { getKAPIs, getOrderGrowth, getPlatformFeeGrowth, getHourlyDistribution, getOrderStatusBreakdown, getRevenueByFoodCourt } from '@services/api/dashboard/dashboardServices';
import { useQuery } from '@tanstack/react-query';
import MetricsData, { OrdersData, PlatformData, HourlyOrderData, OrderStatusData, RevenueByFoodCourtData } from 'types/dashboard/dashboardTypes';

export const useKPAIS = () => {
    const { data, isLoading, error } = useQuery<MetricsData, Error>({
        queryKey: ['cards'],
        queryFn: () => getKAPIs(),
        refetchOnWindowFocus: false
    });
    return { data, isLoading, error };
}

export const useOrderGrowth = () => {
    const { data, isLoading, error } = useQuery<OrdersData, Error>({
        queryKey: ['ordergrowth'],
        queryFn: () => getOrderGrowth(),
        refetchOnWindowFocus: false
    });
    return { data, isLoading, error };
}

export const usePlatformFeeGrowth = () => {
    const { data, isLoading, error } = useQuery<PlatformData, Error>({
        queryKey: ['platformFees'],
        queryFn: () => getPlatformFeeGrowth(),
        refetchOnWindowFocus: false
    });
    return { data, isLoading, error };
}

// ── Analytics hooks ──

export const useHourlyDistribution = () => {
    const { data, isLoading, error } = useQuery<HourlyOrderData[], Error>({
        queryKey: ['hourlyDistribution'],
        queryFn: () => getHourlyDistribution(),
        refetchOnWindowFocus: false
    });
    return { data, isLoading, error };
}

export const useOrderStatusBreakdown = () => {
    const { data, isLoading, error } = useQuery<OrderStatusData[], Error>({
        queryKey: ['orderStatusBreakdown'],
        queryFn: () => getOrderStatusBreakdown(),
        refetchOnWindowFocus: false
    });
    return { data, isLoading, error };
}

export const useRevenueByFoodCourt = () => {
    const { data, isLoading, error } = useQuery<RevenueByFoodCourtData[], Error>({
        queryKey: ['revenueByFoodCourt'],
        queryFn: () => getRevenueByFoodCourt(),
        refetchOnWindowFocus: false
    });
    return { data, isLoading, error };
}